export default {"src":"/_next/static/media/arrow-left-orange.01d29074.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};